<template>
  <div class="custom-table search-table">
    <el-header ref="header" style="height: auto;margin-bottom: 10px;padding: 0">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="gongyingshang">
            <el-input placeholder="请输入供应商" v-model="searchForm.gongyingshang"
                      @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="version">
            <el-input placeholder="请输入库存版本" v-model="searchForm.version"
                      @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-button v-waves :loading="exportLoading" class="filter-item" type="success" icon="el-icon-download"
               size="small" @click="handleExport">导出Excel
    </el-button>
    <el-button size="small" class="el-icon-delete" type="danger" style="margin-left: 10px" @click="handleDelete">
      批量删除
    </el-button>
    <el-table border fit highlight-current-row class="customer-table" :data="list" v-loading="listLoading"
              @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column label="供应商名称" prop="gongyingshang"></el-table-column>
      <el-table-column label="库存版本" prop="version"></el-table-column>
      <el-table-column label="型号数量" prop="num"></el-table-column>
      <el-table-column label="上传日期" prop="upload_date"></el-table-column>
      <!--        <el-table-column label="操作">-->
      <!--          <template v-slot="scope">-->
      <!--            <el-popconfirm-->
      <!--              iconColor="red"-->
      <!--              @confirm="handleDelete({type:'single'},scope, scope.$index)"-->
      <!--              title="确认删除此条数据吗？"-->
      <!--            >-->
      <!--              <el-button slot="reference" size="small" class="el-icon-delete" type="danger">删除</el-button>-->
      <!--            </el-popconfirm>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
    </el-table>
    <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                   :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]" :page-size="selectPage.pageSize"
                   background
                   layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                   style="margin-top: 14px;margin-bottom:14px"
    >
    </el-pagination>
  </div>
</template>
<script>
import {computed, defineComponent, onMounted, reactive, ref} from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import request from '@/utils/request';
import waves from '@/directive/waves'
import {Message} from "element-ui";

export default defineComponent({
  name: 'inventoryQuery',
  components: {PageWrapper},
  directives: {waves},
  setup() {
    const searchFormRef = ref(null)
    const searchForm = reactive({
      gongyingshang: '',
      version: '',
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const list = ref([])
    const listLoading = ref(false)
    const exportLoading = ref(false)


    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const getList = () => {
      listLoading.value = false
      request({
        url: 'overseas_batch_list.yy',
        method: 'post',
        params: selectPage,
        data: searchForm
      }).then(res => {
        const {code, data, total} = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
        }
      })
    }

    onMounted(() => {
      getList()
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList()
    }

    const handleDelete = () => {
      // if (selectVal.value.length === 0) {
      //   Message.error('请至少选择一条数据删除！')
      //   return
      // }
      let params
      if (searchForm.gongyingshang !== '' || searchForm.version !== '') {
        params = searchForm
      } else {
        params = selectVal.value
      }
      request({
        url: 'overseas_inventory_delete.yy',
        method: 'post',
        data: params
      }).then(res => {
        if (res.code == 200) {
          getList()
        }
      })
    }

    const deleteRow = ({type}, index) => {
      // if(type === 'single'){
      // list.value.splice(index, 1)
      // }else{
      //   const idsToDelete = selectId.value.map(row => row);
      //   list.value = list.value.filter(item => !idsToDelete.includes(item.id));
      // }
    }

    //导出excel，且格式化数据
    const formatJson = (data, filterVal) => {
      const newList = JSON.parse(JSON.stringify(data))
      return newList.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
    const handleExport = () => {
      // if (selectVal.value.length === 0) {
      //   Message.error('请至少选择一条数据导出！')
      //   return
      // }
      // exportLoading.value = true
      let params
      if (searchForm.gongyingshang !== '' || searchForm.version !== '') {
        params = searchForm
      } else {
        params = selectVal.value
      }
      request({
        url: 'overseas_inventory_download.yy',
        method: 'post',
        data: params
      }).then(res => {
        if (res.code == 200) {
          import('@/vendor/Export2Excel').then(excel => {
            const tHeader = ['id', '型号', '品牌', '库存数量', '供应商', '库存版本', '原币种',
              '原币价格', '成本价格', '销售价格', '货期', '上传日期']
            const filterVal = ['ID', 'xhname', 'source', 'number', 'gongyingshang', 'version',
              'currency', 'price', 'cost_price', 'selling_price', 'hq', 'upload_date'
            ]
            const data = formatJson(res.data, filterVal)
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '库存批量管理'
            })
            exportLoading.value = false
          })
        }
      })
    }


    //批量选中的值
    const selectVal = ref([])
    const handleSelectionChange = (val) => {
      selectVal.value = val.map(({gongyingshang, version}) => ({gongyingshang, version}))
    }


    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getList()
    }


    return {
      selectVal,
      list,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      exportLoading,
      listLoading,
      searchFormRef,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleSelectionChange,
      handleExport,
      pageSizeChange,
      pageCurrentChange,
      handleDelete,
      deleteRow,
    };
  }
})
</script>
<style scoped lang="scss">
.custom-table {
  padding: 20px;

  .customer-table {
    margin-top: 20px;
  }
}


</style>
